const circleWaveSliderSections = document.querySelectorAll(
  ".circle-wave-slider-section"
);

circleWaveSliderSections.forEach((section) => {
  const slider = section.querySelector(".circle-wave-slider");
  const sliderControls = section.querySelector(".slider-controls");
  const sliderPrev = section.querySelector(".tns-prev");
  const sliderNext = section.querySelector(".tns-next");

  const circleWaveSlider = tns({
    container: slider,
    items: 1,
    slideBy: "page",
    // controls: true,
    nav: false,
    gutter: 16,
    controlsContainer: sliderControls,
    autoplay: true,
    loop: false,
    speed: 1500,
    autoplayButtonOutput: false,
  });
});
